import { render, staticRenderFns } from "./TemplateMenu.vue?vue&type=template&id=674196b0&scoped=true&"
import script from "./TemplateMenu.vue?vue&type=script&lang=ts&"
export * from "./TemplateMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674196b0",
  null
  
)

export default component.exports